import { FileCheck2, FileText, FileType, FileX, ImageIcon } from "lucide-react";
import React from "react";
import { iconData } from "../../iconData";

function SharedFiles({ attachments }) {
    const getFileIcon = (filename) => {
        const ext = filename?.split(".").pop()?.toLowerCase();

        if (["pdf"].includes(ext))
            return <FileCheck2 size={20} className="text-danger" />;
        if (["doc", "docx"].includes(ext))
            return <FileText size={20} className="text-primary" />;
        if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext))
            return <ImageIcon size={20} className="text-success" />;
        if (["xls", "xlsx"].includes(ext))
            return <FileType size={20} className="text-success" />;
        return <FileX size={20} className="text-muted" />;
    };
    const getShortName = (file) => {
        const fileName = file?.split("/").pop();
        const fileNameWithoutId = fileName.split("_")[1];
        return fileNameWithoutId;
    };

    if (!attachments.length) return null;
    return (
        <div className="d-flex flex-row">
            <FileText size={18} className="me-2" />
            <div>
                <h6 className="poppins-semibold  mb-2 d-flex align-items-center">
                    Shared Files ({attachments.length})
                </h6>
                {/*  */}
                <div className="d-flex flex-row gap-2">
                    {attachments.map((file, idx) => {
                        const linkExt = file.startsWith('https');

                        return (
                            <div>
                                {linkExt ? (<img
                                    key={idx} className="d-flex align-items-center gap-2 w-6 h-8"
                                    src='/images/link-icon.png'
                                    alt="extension icon"
                                />) : <img
                                    key={idx} className="d-flex align-items-center gap-2 w-6 h-8"
                                    src={`${iconData?.find(
                                        (i) =>
                                            i.extension ===
                                            file?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                        }`}
                                    alt="extension icon"
                                />}
                            </div>
                        )
                    })}

                </div>
            </div>
        </div>
    );
}

export default SharedFiles;
